var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.218,
    height: 30.219,
    viewBox: "0 0 30.218 30.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(-1501.141 -64.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M2266.25,163.179a15.109,15.109,0,1,1-15.109,15.11,15.109,15.109,0,0,1,15.109-15.11",
    transform: "translate(-750 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M2266.25,170.49c2.54,0,2.841.01,3.844.055a5.267,5.267,0,0,1,1.767.328,3.143,3.143,0,0,1,1.8,1.8,5.3,5.3,0,0,1,.328,1.767c.046,1,.055,1.3.055,3.844s-.009,2.84-.055,3.844a5.281,5.281,0,0,1-.328,1.766,3.141,3.141,0,0,1-1.8,1.806,5.267,5.267,0,0,1-1.767.328c-1,.046-1.3.054-3.844.054s-2.841-.008-3.844-.054a5.267,5.267,0,0,1-1.767-.328,3.141,3.141,0,0,1-1.8-1.806,5.281,5.281,0,0,1-.328-1.766c-.046-1-.055-1.3-.055-3.844s.009-2.841.055-3.844a5.3,5.3,0,0,1,.328-1.767,3.143,3.143,0,0,1,1.8-1.8,5.267,5.267,0,0,1,1.767-.328c1-.045,1.3-.055,3.844-.055m0-1.715c-2.584,0-2.908.012-3.922.058a6.989,6.989,0,0,0-2.31.442,4.866,4.866,0,0,0-2.782,2.783,6.978,6.978,0,0,0-.442,2.309c-.046,1.014-.057,1.339-.057,3.922s.011,2.908.057,3.922a6.985,6.985,0,0,0,.442,2.31,4.861,4.861,0,0,0,2.782,2.782,6.988,6.988,0,0,0,2.31.442c1.014.047,1.338.057,3.922.057s2.908-.01,3.922-.057a6.988,6.988,0,0,0,2.31-.442,4.861,4.861,0,0,0,2.782-2.782,6.985,6.985,0,0,0,.442-2.31c.046-1.014.057-1.338.057-3.922s-.011-2.908-.057-3.922a6.978,6.978,0,0,0-.442-2.309,4.866,4.866,0,0,0-2.782-2.783,6.989,6.989,0,0,0-2.31-.442c-1.014-.046-1.338-.058-3.922-.058",
    transform: "translate(-750 -98.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2266.25,173.4a4.885,4.885,0,1,0,4.885,4.886,4.886,4.886,0,0,0-4.885-4.886m0,8.057a3.171,3.171,0,1,1,3.171-3.171,3.171,3.171,0,0,1-3.171,3.171",
    transform: "translate(-750 -98.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M2272.47,173.21a1.141,1.141,0,1,1-1.142-1.141,1.142,1.142,0,0,1,1.142,1.141",
    transform: "translate(-750 -98.69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.631701b734e3ea81ee8b84e248f3ffa9.svg";
export { ForwardRef as ReactComponent };